import { render, staticRenderFns } from "./BaseBlock.vue?vue&type=template&id=08483b88"
import script from "./BaseBlock.vue?vue&type=script&lang=js"
export * from "./BaseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08483b88')) {
      api.createRecord('08483b88', component.options)
    } else {
      api.reload('08483b88', component.options)
    }
    module.hot.accept("./BaseBlock.vue?vue&type=template&id=08483b88", function () {
      api.rerender('08483b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseBlock.vue"
export default component.exports